<template>
    <GeneralDialog v-model="visible" title="Choose Your avatar" @close="close">
        <div class="choose">
            <div class="choose-area">
                <div
                    :class="['item', { active: avatarIdx === index }]"
                    v-for="(item, index) in partnerInfo.avatarList"
                    :key="index"
                    @click="change(index)"
                >
                    <img :src="item" />
                </div>
            </div>
            <div class="btn" @click="handleConfirm">{{ $t('Confirm') }}</div>
        </div>
    </GeneralDialog>
</template>
<script setup lang="ts">
import { useBaseStore } from '@/stores'
import { storeToRefs } from 'pinia'
import GeneralDialog from '@/components/dialog/generalDialog.vue'
import { setAvatarPic } from '@/api/partner'

const visible = defineModel()
const store = useBaseStore()
const { partnerInfo } = storeToRefs(store)
const avatarIdx = ref(0)

const handleConfirm = () => {
    setAvatarPic(avatarIdx.value).then((res) => {
        if (res.code === 200) {
            partnerInfo.value.avatar = res.avatar
            visible.value = false
        }
    })
}
const change = (index) => {
    if (avatarIdx.value === index) {
        return
    }
    avatarIdx.value = index
}
const close = () => {
    if (partnerInfo.value.avatar) {
        setAvatarPic(-1).then((res) => {
            if (res.code === 200) {
                partnerInfo.value.avatarList = []
                visible.value = false
            }
        })
    }
}
</script>
<style lang="scss" scoped>
.choose {
    padding-top: 33px;
    height: 937px;
    background: linear-gradient(#42355a, #42355a), linear-gradient(#2a2d3b, #2a2d3b);

    .choose-area {
        @apply flex flex-wrap justify-between gap-[39px];
        padding: 0 73px;

        .item {
            position: relative;
            width: 252px;
            height: 336px;
            border-radius: 30px;
            // overflow: hidden;
            border: solid 8px #42355a;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 26px;
            }

            &.active {
                border: solid 8px #f2b441;
                &::after {
                    position: absolute;
                    right: -5px;
                    bottom: -2px;
                    content: '';
                    width: 52px;
                    height: 53px;
                    background: url('@/assets/img/wallets/checked.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }
    .btn {
        @apply flex justify-center items-center;
        margin: 44px auto 0;
        width: 440px;
        height: 88px;
        background-image: linear-gradient(0deg, #fa3374 0%, #fd578d 60%, #ff7aa5 100%), linear-gradient(#e59e20, #e59e20);
        background-blend-mode: normal, normal;
        border-radius: 44px;
        font-size: 36px;
    }
}
</style>
